import { render, staticRenderFns } from "./FocusIndicator.vue?vue&type=template&id=31d529aa&scoped=true&"
import script from "./FocusIndicator.vue?vue&type=script&lang=ts&"
export * from "./FocusIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./FocusIndicator.vue?vue&type=style&index=0&id=31d529aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d529aa",
  null
  
)

export default component.exports